import { GetterTree } from "vuex";
import { StateInterface } from "src/store";
import { CubeStateInterface } from "./state";

const getters: GetterTree<CubeStateInterface, StateInterface> = {
  getDashboards(state) {
    return state.dashboards
      .filter(() => true)
      .sort((a, b) => a.name.localeCompare(b.name));
  },

  getChartTypes(state) {
    return state.chartTypes.filter(() => true);
  },

  getReports(state) {
    return state.reports.filter(() => true);
  },
};

export default getters;
